exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.avatar-uploader-icon {\n\tfont-size: 28px;\n\tcolor: #8c939d;\n\twidth: 178px;\n\theight: 178px;\n\tline-height: 178px;\n\ttext-align: center;\n}\n.avatar {\n\theight: 178px;\n\tdisplay: block;\n}\n", ""]);

// exports
